import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _Map from '@babel/runtime-corejs3/core-js/map';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js/instance/find';
import React__default from 'react';
import { api } from '@bilibili-maoer/web-utils';
import useMount from 'react-use/lib/useMount';
import { EEmotePackageType } from '../enum.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var EMOTE_URL_PREFIX = "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/emote");
var EMOTE_PKG_URL = "".concat(EMOTE_URL_PREFIX, "/package.json");
var appendEmotePrefix = function appendEmotePrefix(path) {
  var _context;

  return _concatInstanceProperty(_context = "".concat(EMOTE_URL_PREFIX, "/")).call(_context, path);
};
var EPackageState;

(function (EPackageState) {
  /** 表情包是锁定表情包，但是暂时不知道是否锁定，此时表情包应该隐藏，内容中不渲染 */
  EPackageState[EPackageState["ExclusivePackageButStateUnknown"] = 1] = "ExclusivePackageButStateUnknown";
  /** 表情包是锁定状态，但是表情包数据还没有获取到，此时没有表情包数据，内容中不渲染 */

  EPackageState[EPackageState["LockedPackageButPackageUnknown"] = 2] = "LockedPackageButPackageUnknown";
  /** 表情包是解锁状态，但是表情包数据还没有获取到，此时没有表情包数据，内容不渲染  */

  EPackageState[EPackageState["UnlockedPackageButPackageUnknown"] = 3] = "UnlockedPackageButPackageUnknown";
  /** 表情包锁定，此时展示表情包锁定态，内容中不渲染  */

  EPackageState[EPackageState["Locked"] = 4] = "Locked";
  /** 表情包可用，正常显示表情包，内容中渲染 */

  EPackageState[EPackageState["Available"] = 5] = "Available";
})(EPackageState || (EPackageState = {}));

var BIG_EMOTE_SIZE = 50;
var SMALL_EMOTE_SIZE = 22;
var VISIBLE_STATES_IN_COMMENTS = [EPackageState.Available];
var EmoteContext = /*#__PURE__*/React__default.createContext({
  data: null,
  isReady: false,
  lock: function lock() {},
  unlock: function unlock() {},
  emotePackagesState: {},
  formatEmotes: function formatEmotes(content) {
    return content;
  }
});
var RETRY_LIMIT = 3;
var EmoteContextProvider = function EmoteContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React__default.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      emotePackagesState = _React$useState2[0],
      setEmotePackageStates = _React$useState2[1];

  var _React$useState3 = React__default.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      emoteData = _React$useState4[0],
      setEmoteData = _React$useState4[1];

  var _React$useState5 = React__default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isReady = _React$useState6[0],
      setIsReady = _React$useState6[1];

  var retryCount = React__default.useRef(0);
  var lockInfoRef = React__default.useRef({});

  var transitPackageState = function transitPackageState(id, transfer) {
    setEmotePackageStates(function (old) {
      var newState = transfer(old[id]);

      if (!newState) {
        return old;
      }

      return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, id, newState));
    });
  };

  var setPackage = function setPackage(packageId, partial) {
    setEmoteData(function (old) {
      var _context2;

      if (!old) {
        return null;
      }

      return _objectSpread(_objectSpread({}, old), {}, {
        packages: old === null || old === void 0 ? void 0 : _mapInstanceProperty(_context2 = old.packages).call(_context2, function (pkg) {
          if (pkg.id === packageId) {
            return _objectSpread(_objectSpread({}, pkg), partial);
          }

          return pkg;
        })
      });
    });
  };

  var setIsExclusivePackage = React__default.useCallback(function (packageId, isExclusivePackage) {
    transitPackageState(packageId, function (oldState) {
      // 如果有其他接口提供的锁定信息（可用时间段等），加入表情包信息中
      if (lockInfoRef.current[packageId]) {
        setPackage(packageId, lockInfoRef.current[packageId]);
      } // 不是可锁定表情包，直接变为可用状态


      if (!isExclusivePackage) {
        return EPackageState.Available;
      } // 是可锁定表情包，但是暂时没有锁定信息，变为锁定表情包但是状态未知


      if (!oldState) {
        return EPackageState.ExclusivePackageButStateUnknown;
      } // 是可锁定表情包，且当前为锁定状态，变为锁定状态


      if (oldState === EPackageState.LockedPackageButPackageUnknown) {
        return EPackageState.Locked;
      } // 是可锁定表情包，且当前为解锁状态，变为可用状态


      if (oldState === EPackageState.UnlockedPackageButPackageUnknown) {
        return EPackageState.Available;
      }

      return null;
    });
  }, []);

  var lock = function lock(packageId, lockInfo) {
    transitPackageState(packageId, function (oldState) {
      if (!oldState) {
        // 还没有获取到表情包数据，先缓存锁定信息
        lockInfoRef.current[packageId] = lockInfo;
        return EPackageState.LockedPackageButPackageUnknown;
      } // 是可锁定表情包，直接变为锁定状态


      if (oldState === EPackageState.ExclusivePackageButStateUnknown) {
        setPackage(packageId, lockInfo);
        return EPackageState.Locked;
      }

      return null;
    });
  };

  var unlock = function unlock(packageId, lockInfo) {
    transitPackageState(packageId, function (oldState) {
      if (!oldState) {
        // 还没有获取到表情包数据，先缓存 lockInfo
        lockInfoRef.current[packageId] = lockInfo;
        return EPackageState.UnlockedPackageButPackageUnknown;
      } // 以下两种情况变为可用状态
      // 1. 是可锁定表情包
      // 2. 当前是锁定状态，但是在浏览过程中解锁了


      if (oldState === EPackageState.ExclusivePackageButStateUnknown || oldState === EPackageState.Locked) {
        setPackage(packageId, lockInfo);
        return EPackageState.Available;
      }

      return null;
    });
  };

  var fetchEmotePackages = React__default.useCallback(function () {
    fetch(EMOTE_PKG_URL, {
      method: 'GET',
      mode: 'cors'
    }).then(function (r) {
      return r.json();
    }).then(function (r) {
      var res = _objectSpread(_objectSpread({}, r), {}, {
        emoteMap: new _Map()
      });

      r.packages.forEach(function (pkg) {
        pkg.image_url = appendEmotePrefix(pkg.image_url);
        pkg.emote.forEach(function (emote) {
          if (emote.image_url) {
            emote.image_url = appendEmotePrefix(emote.image_url);
          }

          var augmentedEmote = _objectSpread(_objectSpread({}, emote), {}, {
            type: pkg.type
          });

          res.emoteMap.set(augmentedEmote.text, augmentedEmote);
        });
      }); // NOTICE: 在状态转移前需要设置 emoteData，如果后面再设置的话可能会覆盖掉从其他接口获取的字段，如锁定文案

      setEmoteData(res);
      r.packages.forEach(function (pkg) {
        setIsExclusivePackage(pkg.id, !!pkg.exclusive);
      });
      setIsReady(true);
    }).catch(function () {
      if (retryCount.current < RETRY_LIMIT) {
        retryCount.current++;
        fetchEmotePackages();
      } else {
        setIsReady(true);
      }
    });
  }, [setIsExclusivePackage]);
  var formatEmotes = React__default.useCallback(function (content, publishTime) {
    if (!emoteData || !emoteData.packages) {
      return content;
    }

    return content.replace(/(\[[^\]]+\])/g, function (text) {
      var _context3, _context4, _context5, _context6;

      var emote = emoteData.emoteMap.get(text);

      if (!emote || !_includesInstanceProperty(VISIBLE_STATES_IN_COMMENTS).call(VISIBLE_STATES_IN_COMMENTS, emotePackagesState[emote.package_id])) {
        return text;
      }

      var _ref2 = _findInstanceProperty(_context3 = emoteData.packages).call(_context3, function (_ref3) {
        var id = _ref3.id;
        return id === emote.package_id;
      }) || {},
          _ref2$startTime = _ref2.startTime,
          startTime = _ref2$startTime === void 0 ? 0 : _ref2$startTime,
          _ref2$endTime = _ref2.endTime,
          endTime = _ref2$endTime === void 0 ? Number.POSITIVE_INFINITY : _ref2$endTime; // 一些旧的评论接口 ctime 仍然是 string 类型，如果 ctime 不是时间戳，为兼容性考虑，不执行限时表情包的限时显示逻辑


      if (typeof publishTime === 'number' && (publishTime < startTime || publishTime >= endTime)) {
        return text;
      }

      return _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = "<img class=".concat(emote.type === EEmotePackageType.Big ? 'big' : 'small', " alt=\"")).call(_context6, text, "\" src=\"")).call(_context5, emote.image_url, "\" width=\"")).call(_context4, emote.type === EEmotePackageType.Big ? BIG_EMOTE_SIZE : SMALL_EMOTE_SIZE, "\" />");
    });
  }, [emoteData, emotePackagesState]);
  useMount(function () {
    fetchEmotePackages();
  });
  return /*#__PURE__*/React__default.createElement(EmoteContext.Provider, {
    value: {
      data: emoteData,
      isReady: isReady,
      lock: lock,
      unlock: unlock,
      emotePackagesState: emotePackagesState,
      formatEmotes: formatEmotes
    }
  }, children);
};
var useEmotes = function useEmotes() {
  return React__default.useContext(EmoteContext);
};

export { EPackageState, EmoteContextProvider, VISIBLE_STATES_IN_COMMENTS, appendEmotePrefix, useEmotes };
